import api from './api';

/** Insurer business report -- `/api/v1/insurers/insurance/reports/business/` (board #362). */

export interface BusinessReportFilters {
  date_from?: string;
  date_to?: string;
}

export interface BusinessReport {
  basis: { premium: string; excludes: string[]; month_from: string; scope: string };
  totals: { gross_written_premium: string; policy_count: number; cancelled_policies: number };
  by_broker: Array<{ broker_id: string; broker_name: string; policy_count: number; premium: string }>;
  by_product: Array<{ product_id: string | null; product_name: string; policy_count: number; premium: string }>;
  by_month: Array<{ month: string; policy_count: number; premium: string }>;
}

const URL = '/insurers/insurance/reports/business/';

function clean(filters: BusinessReportFilters) {
  return Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
}

export const insurerReportsApi = {
  async business(filters: BusinessReportFilters): Promise<BusinessReport> {
    const { data } = await api.get<BusinessReport>(URL, { params: clean(filters) });
    return data;
  },

  async businessCsv(filters: BusinessReportFilters): Promise<Blob> {
    const res = await api.get(URL, { params: { ...clean(filters), export: 'csv' }, responseType: 'blob' });
    return res.data as Blob;
  },
};
